module.exports = __webpack_public_path__ + "static/media/Offerings.52da9feb.png";